const STORAGE_KEY = "psx-interactions-saved-settings";
export class SavedSettingsStorage {
    static getAll() {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : {};
        }
        catch (error) {
            console.error("Failed to load saved settings:", error);
            return {};
        }
    }
    static getById(id) {
        const all = this.getAll();
        return all[id] || null;
    }
    static save(settings) {
        try {
            const all = this.getAll();
            const now = new Date().toISOString();
            const updatedSettings = {
                ...settings,
                dateModified: now,
                dateCreated: settings.dateCreated || now,
            };
            all[settings.id] = updatedSettings;
            localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
        }
        catch (error) {
            console.error("Failed to save settings:", error);
            throw new Error("Failed to save settings. Please try again.");
        }
    }
    static delete(id) {
        try {
            const all = this.getAll();
            delete all[id];
            localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
        }
        catch (error) {
            console.error("Failed to delete settings:", error);
            throw new Error("Failed to delete settings. Please try again.");
        }
    }
    static nameExists(name, excludeId) {
        const all = this.getAll();
        const normalizedName = name.toLowerCase().trim();
        return Object.values(all).some((setting) => setting.name.toLowerCase().trim() === normalizedName && setting.id !== excludeId);
    }
    static findByName(name) {
        const all = this.getAll();
        const normalizedName = name.toLowerCase().trim();
        const found = Object.values(all).find((setting) => setting.name.toLowerCase().trim() === normalizedName);
        return found || null;
    }
    static generateId() {
        return `settings-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    }
    static getAllAsArray() {
        const all = this.getAll();
        return Object.values(all).sort((a, b) => new Date(b.dateModified).getTime() - new Date(a.dateModified).getTime());
    }
    static rename(id, newName) {
        const setting = this.getById(id);
        if (!setting) {
            throw new Error("Settings not found");
        }
        if (this.nameExists(newName, id)) {
            throw new Error("A setting with this name already exists");
        }
        const updatedSetting = {
            ...setting,
            name: newName.trim(),
            dateModified: new Date().toISOString(),
        };
        this.save(updatedSetting);
    }
    static exportAll() {
        return JSON.stringify(this.getAll(), null, 2);
    }
    static importAll(jsonData) {
        try {
            const imported = JSON.parse(jsonData);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(imported));
        }
        catch (error) {
            console.error("Failed to import settings:", error);
            throw new Error("Invalid settings data. Please check the format and try again.");
        }
    }
}
//# sourceMappingURL=savedSettingsStorage.js.map